import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_ROOT } from "../../../services/api";
import RightCaretIcon from "../../Layout/Icons/RightCaretIcon";
import Dialog from "../../Dialog";

import HighlightActiveStep from "./HighlightActiveStep";

const HeaderSteps = ({
  currentPage,
  routeId,
  numInvalidElements,
  location,
  areAnyColorsOutOfStock
}) => {
  const [showInvalidDialog, setShowInvalidDialog] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Always show dialog on mobile when elements are invalid
    if (isMobile && numInvalidElements > 0) {
      setShowInvalidDialog(true);
    }
  }, [numInvalidElements, isMobile]);

  const hideInvalidDialog = () => {
    setShowInvalidDialog(false);
  };

  const reviewEnabled =
    numInvalidElements === 0 && areAnyColorsOutOfStock !== true
      ? "enabled"
      : "disabled";

  const handleAddToCartClick = (e) => {
    if (numInvalidElements > 0 || areAnyColorsOutOfStock === true) {
      e.preventDefault();
      // Show the dialog when attempting to click the button
      if (numInvalidElements > 0) {
        setShowInvalidDialog(true);
      }
    }
  };

  const invalidDesignDialog = {
    title: "Design Notice",
    message:
      "Your current design is outside the printable area. Please adjust it before continuing.",
    topPosition: 0,
    leftPosition: "auto",
    origin: "topright",
    type: ""
  };

  if (currentPage === "customize") {
    return (
      <>
        <ul className="header__steps">
          <li className="header__step active header__step--customize">
            <div className="header__step__item">
              <div className="header__step__text">
                <span className="desktop-text">1. Customize</span>
                <span className="mobile-text">Customize</span>
                <div className="mobile-indicator"></div>
                <HighlightActiveStep />
              </div>
            </div>
          </li>

          <li
            className={`header__step header__step--review ${reviewEnabled} mobile-hide-review`}
          >
            <div className="header__step__item">
              <Link
                to={{ pathname: `/${routeId}/review`, search: location.search }}
                className="header__step__text"
              >
                <span className="desktop-text">2. Review &amp; Approve</span>
                <span className="mobile-text">Review</span>
                <div className="mobile-indicator"></div>
                <HighlightActiveStep />
              </Link>
            </div>
          </li>

          <li className={`header__step header__step--cart ${reviewEnabled}`}>
            <div className="header__step__item">
              <Link
                to={{ pathname: `/${routeId}/review`, search: location.search }}
                className={`header__step__text cart-button${numInvalidElements > 0 || areAnyColorsOutOfStock ? " disabled" : ""}`}
                onClick={handleAddToCartClick}
                aria-disabled={numInvalidElements > 0 || areAnyColorsOutOfStock}
              >
                <span>Add to Cart</span>
                <span className="mobile-hide-caret">
                  <RightCaretIcon />
                </span>
              </Link>
            </div>
          </li>
        </ul>

        {/* Mobile validation indicator */}
        {isMobile && numInvalidElements > 0 && (
          <div className="mobile-validation-indicator">
            Design is outside printable area
          </div>
        )}

        {/* Invalid design dialog for mobile view */}
        {numInvalidElements > 0 && showInvalidDialog && (
          <div className="mobile-dialog-container">
            <Dialog
              dialog={invalidDesignDialog}
              onHideDialog={hideInvalidDialog}
            />
          </div>
        )}
      </>
    );
  } else {
    return (
      <ul className="header__steps">
        <li className="header__step header__step--customize">
          <div className="header__step__item">
            <Link
              className="header__step__text"
              to={{
                pathname: `/${routeId}/customize/style`,
                search: location.search
              }}
            >
              <span className="desktop-text">1. Customize</span>
              <span className="mobile-text">Customize</span>
              <div className="mobile-indicator"></div>
              <HighlightActiveStep />
            </Link>
          </div>
        </li>

        <li className="header__step active header__step--review">
          <div className="header__step__item">
            <div className="header__step__text">
              <span className="desktop-text">2. Review &amp; Approve</span>
              <span className="mobile-text">Review</span>
              <div className="mobile-indicator"></div>
              <HighlightActiveStep />
            </div>
          </div>
        </li>

        <li className="header__step header__step--cart">
          <div className="header__step__item">
            <a
              href={`${API_ROOT}cart`}
              className="header__step__text cart-button"
            >
              <span>Add to Cart</span>
              <RightCaretIcon />
            </a>
          </div>
        </li>
      </ul>
    );
  }
};

export default HeaderSteps;
